type Info = Partial<{
  [key: string]: any;
}>;

type success = () => void;

enum APIEnum {
  moment = 'WeChatMoments',
  wechat = 'WeChatSession'
}

const API_MAP = {
  [APIEnum.moment]: 'onMenuShareTimeline',
  [APIEnum.wechat]: 'onMenuShareAppMessage'
};

export default function shareWechat(info: Info, type) {
  return new Promise((resolve, reject) => {
    window.wx[API_MAP[type]]?.({
      ...info,
      success: resolve,
      cancel: reject
    });
  });
}
